import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import DirectionsCarFilledRoundedIcon from '@mui/icons-material/DirectionsCarFilledRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import VideoCameraFrontRoundedIcon from '@mui/icons-material/VideoCameraFrontRounded';
import type SvgIcon from '@mui/material/SvgIcon';

export type SidebarIconComponent = typeof SvgIcon;

export const sidebarIcons = {
  rides: DirectionsCarFilledRoundedIcon,
  riders: GroupsRoundedIcon,
  locations: LocationOnRoundedIcon,
  calendars: CalendarMonthRoundedIcon,
  recordings: VideoCameraFrontRoundedIcon,
  reports: AssessmentRoundedIcon,
  helpCenter: HelpRoundedIcon,
  profile: AccountCircleRoundedIcon,
};
